// =============================================
// src/components/modals/ToolsModal.jsx
// =============================================

import React from "react";
import { X } from "lucide-react";
import { AVAILABLE_TOOLS } from "../../utils/constants";

export default function ToolsModal({ open, onClose }) {
  if (!open) return null;

  const toolsByType = AVAILABLE_TOOLS.reduce((acc, tool) => {
    if (!acc[tool.type]) acc[tool.type] = [];
    acc[tool.type].push(tool);
    return acc;
  }, {});

  return (
    <>
      <div
        style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15,23,42,0.75)", backdropFilter: "blur(4px)", zIndex: 999 }}
        onClick={onClose}
      />
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "28px",
          maxWidth: "800px",
          width: "90%",
          maxHeight: "85vh",
          overflow: "auto",
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
          zIndex: 1000,
          border: "1px solid #e2e8f0",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "24px" }}>
          <div>
            <h3 style={{ margin: "0 0 8px 0", color: "#0f172a", fontSize: "24px", fontWeight: 700 }}>Available Tools & Databases</h3>
            <p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>AlzTxPILOT integrates these specialized resources for AD research</p>
          </div>
          <button
            onClick={onClose}
            style={{ background: "transparent", border: "none", fontSize: "24px", cursor: "pointer", color: "#64748b", padding: 0, width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "6px" }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f1f5f9";
              e.currentTarget.style.color = "#0f172a";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#64748b";
            }}
          >
            <X size={20} />
          </button>
        </div>

        {Object.entries(toolsByType).map(([type, tools]) => (
          <div key={type} style={{ marginBottom: "24px" }}>
            <h4 style={{ fontSize: "14px", fontWeight: 600, color: "#0891b2", marginBottom: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>{type}</h4>
            {tools.map((tool) => (
              <div
                key={tool.name}
                style={{ padding: "16px", backgroundColor: "#f8fafc", borderRadius: "8px", marginBottom: "12px", border: "1px solid #e2e8f0", transition: "all 0.2s ease" }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.borderColor = "#0891b2";
                  e.currentTarget.style.transform = "translateX(4px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#f8fafc";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                  e.currentTarget.style.transform = "translateX(0)";
                }}
              >
                <div style={{ fontSize: "16px", fontWeight: 600, color: "#0f172a", marginBottom: "6px" }}>{tool.name}</div>
                <p style={{ fontSize: "14px", color: "#64748b", margin: "0 0 10px 0", lineHeight: 1.5 }}>{tool.description}</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {tool.functions.map((fn) => (
                    <span key={fn} style={{ fontSize: "12px", fontFamily: "monospace", backgroundColor: "#e0f2fe", color: "#0369a1", padding: "2px 8px", borderRadius: "4px", fontWeight: 500 }}>
                      {fn}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}
